import React from 'react';
import { formatCurrency } from '../../lib/helpers/formatters';
import { getSection } from '../../lib/helpers/getReportSection';

function BilledField({ data = {}, subAdmins }) {
  let { iaf = {}, iafs = [], iafsSubAdmins = [] } = data;
  iafs = iafs || [];
  iafsSubAdmins = iafsSubAdmins || [];

  let totalPaid = 0;

  if (subAdmins) {
    totalPaid = iafsSubAdmins.reduce(
      (acc, iaf = {}) => acc + (iaf['invoices'][0]?.earnedAdminShare || 0),
      0
    );
  } else {
    const section = getSection(data);

    if (!section) return <>{formatCurrency(0)}</>;

    if (section === 'signals' && iaf._id) {
      totalPaid = data.adminShare || 0;
    } else {
      totalPaid = iafs.reduce(
        (acc, iaf = {}) =>
          acc +
          (iaf[section][0]?.earnedAdminShare ||
            iaf[section][0]?.adminShare ||
            0),
        0
      );
    }
  }

  if (typeof Number(totalPaid) !== 'number') return <>{formatCurrency(0)}</>;

  return <>{formatCurrency(totalPaid)}</>;
}

export default BilledField;
